import { render } from "./SportPage.vue?vue&type=template&id=45382cc4&scoped=true"
import script from "./SportPage.vue?vue&type=script&lang=js"
export * from "./SportPage.vue?vue&type=script&lang=js"

import "./SportPage.vue?vue&type=style&index=0&id=45382cc4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45382cc4"]])

export default __exports__